export default __webpack_public_path__ + "static/media/goshen44.9415ac52.jpg";